<template>
    <div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{title}}</h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pb-0">
                        <p>{{message}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect waves-themed" @click="toggleModal = false">{{$t('button_link.cancel')}}</button>
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="performConfirmAction">{{$t('button_link.yes')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'modal',
    data(){
        return{
            title: "", message: "", toggleModal: false
        }
    },
    methods:{
        showModal(title, message){
            this.title = title
            this.message = message
            this.toggleModal = true
        },
        performConfirmAction(){
            this.$emit('performConfirmAction')
        }
    }
}
</script>
<style scoped>
.show{
    display: block;
}

</style>